import { render } from "./DbSaveBlockDialog.vue?vue&type=template&id=04c87ed5"
import script from "./DbSaveBlockDialog.vue?vue&type=script&lang=js"
export * from "./DbSaveBlockDialog.vue?vue&type=script&lang=js"

import "./DbSaveBlockDialog.vue?vue&type=style&index=0&id=04c87ed5&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__